import type { GroupInfo, GroupMemberJoinMode } from '@halo/chat-sdk-react';
import ReceiverActions from './receiverActions';

interface FooterActionsProps {
  group: GroupInfo & { mode: GroupMemberJoinMode };
  onClose?: () => void;
}

const FooterActions = ({ group, onClose }: FooterActionsProps) => {
  return <ReceiverActions group={group} onClose={onClose} />;
};

const MemoizedFooterActions = memo(FooterActions);

export { MemoizedFooterActions as FooterActions };
